<div class="confirmation" *ngIf="car$ | async as car">

  <div class="heading">
    Your booking details
  </div>

  <div class="card">

    <div class="car-info">

      <div class="car-wrapper">
        <div class="car-image-container">
          <img class="car-image" [src]="this.car.vehicle.image" [alt]="car.vehicle.make_model" imgPlaceholder>
        </div>

        <div class="car-descr">
          <div class="car-name">{{ car.vehicle.make_model }} {{ car.vehicle.transmission_type }}</div>
        </div>

        <div class="fleet-logo-container">
          <img class="fleet-logo" [src]="fleetLogoUrl$ | async" [alt]="'Fleet logo'" imgPlaceholder>
        </div>
      </div>

      <car-icon-list [alignCenter]="true" [car]="car$ | async"></car-icon-list>

    </div>

    <div class="additional">

      <div class="options" [formGroup]="additionalOptionsForm">
        <div class="section-title">
          Additional options
        </div>

        <ng-container *ngIf="allAdditionalItems$ | async as allItems">
          <ng-container *ngFor="let item of allItems">
            <div class="option">
              <div class="option-name">{{ getItemDescription(item) }}</div>
              <car-count-control
                [amount]="getItemTotalPrice(item, (bookingDays$ | async)!)"
                [formControlName]="countControlName(item)"
              ></car-count-control>
            </div>
          </ng-container>
        </ng-container>

      </div>

      <div class="vertical"></div>

      <div class="summary">
        <div class="section-title">
          Price summary
        </div>

        <div class="price-list">
          <div class="price-list-item">

            <ng-container>
              <div class="price-item-name">VEHICLE RENT {{ bookingDays$ | async }} {{ (bookingDays$ | async)! > 1 ? 'days' : 'day' | uppercase }}</div>
            </ng-container>

            <div *ngFor="let item of appliedEquipment" class="price-item-name">{{ item.name }}</div>
          </div>

          <div class="vertical"></div>

          <div class="price-list-item">
            <div class="price-item">
              {{ currency$ | async }} {{ carCalculationsService.getVehicleRentPriceWithVat((bookingDays$ | async)!) | number: '1.2-2' }}
            </div>
            <div *ngFor="let item of appliedEquipment" class="price-item">
              {{ currency$ | async }} {{ item.price | number: '1.2-2' }}
            </div>
          </div>
        </div>

        <div class="total">
          <div class="section-title total-title">
            Total price
          </div>

          <div class="total-quantity">
            {{ currency$ | async }} {{ carCalculationsService.getTotalAmountWithVat((equipmentTotal$ | async)!, (bookingDays$ | async)!) | number: '1.2-2' }}
          </div>
        </div>
      </div>

    </div>

    <div class="personal full-section" [formGroup]="personalForm">
      <div class="section-title full">Personal info</div>

      <div class="form-row">
        <div class="form-group full-width">
          <p class="title dark required">First name</p>
          <nb-form-field>
            <input
              formControlName="first_name"
              fullWidth
              shape="round"
              size="tiny"
              nbInput
              placeholder="Johny"
            >
          </nb-form-field>
          <car-error-message [control]="personalForm.controls['first_name']"></car-error-message>
        </div>
        <div class="form-group full-width">
          <p class="title dark required">Last name</p>
          <nb-form-field>
            <input
              formControlName="last_name"
              fullWidth
              shape="round"
              size="tiny"
              nbInput
              placeholder="Depp"
            >
          </nb-form-field>
          <car-error-message [control]="personalForm.controls['last_name']"></car-error-message>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group full-width">
          <p class="title dark required">Email</p>
          <nb-form-field>
            <input
              formControlName="email"
              fullWidth
              type="email"
              shape="round"
              size="tiny"
              nbInput
              placeholder="email@example.com"
            >
          </nb-form-field>
          <car-error-message [control]="personalForm.controls['email']"></car-error-message>
        </div>
        <div class="form-row-half">
          <div class="form-group full-width">
            <p class="title dark required">Telephone</p>
            <nb-form-field>
              <input
                prefix="+ "
                mask="0*"
                [dropSpecialCharacters]="false"
                type="tel"
                formControlName="phone_number"
                fullWidth
                shape="round"
                size="tiny"
                nbInput
                placeholder="+00000000000"
              >
            </nb-form-field>
            <car-error-message [control]="personalForm.controls['phone_number']"></car-error-message>
          </div>
          <div class="form-group full-width">
            <p class="title dark">Flight nr.</p>
            <nb-form-field>
              <input
                formControlName="flight_number"
                fullWidth
                shape="round"
                size="tiny"
                nbInput
                placeholder="123456"
              >
            </nb-form-field>
            <car-error-message [control]="personalForm.controls['flight_number']"></car-error-message>
          </div>
        </div>
      </div>
    </div>

    <div class="payment full-section">
      <div class="section-title full">payment information</div>

      <div class="pricing">

        <div class="pricing-block">

          <div class="left">
            <div class="price-item">BOOKING FEE</div>
            <div class="price-item">DESK PAYMENT</div>
          </div>
          <div class="right">
            <div class="price-item">{{ currency$ | async }} {{ carCalculationsService.getPrepaymentAmount((equipmentTotal$ | async)!, (bookingDays$ | async)!) | number: '1.2-2' }}</div>
            <div class="price-item">{{ currency$ | async }} {{ carCalculationsService.getDeskPaymentAmount((equipmentTotal$ | async)!, (bookingDays$ | async)!) | number: '1.2-2' }}</div>
          </div>

        </div>
        <div class="horizontal"></div>
        <div class="pricing-block">
          <div class="left">
            <div class="price-item">TOTAL PAYMENT</div>
          </div>
          <div class="right">
            <div class="price-item">{{ currency$ | async }} {{ carCalculationsService.getTotalAmountWithVat((equipmentTotal$ | async)!, (bookingDays$ | async)!) | number: '1.2-2' }}</div>
          </div>
        </div>
        <div class="horizontal" *ngIf="(currency$ | async) !== 'EUR'"></div>
      </div>
      <div class="pricing-block" *ngIf="(currency$ | async) !== 'EUR'">
          <span style="text-align: center;">All rates are in local currency (EUR) and are converted to {{ currency$ | async }}.<br>
            Due to the changing exchange rates, the final price in your currency may vary.</span>
      </div>
    </div>

    <div class="terms">
      <nb-checkbox [(ngModel)]="agreedWithTerms">
        <span class="terms-text">Agree with <a class="terms-link" href="#" (click)="openTermsConditions($event)">CarBro terms</a></span>
      </nb-checkbox>
    </div>

    <div class="terms" *ngIf="(fleetTermsUrl$ | async) as fleetTermsUrl">
      <nb-checkbox [(ngModel)]="agreedWithFleetTerms">
      </nb-checkbox>
      <span class="terms-text">
        <a [href]="fleetTermsUrl" target="_blank" rel="noopener noreferrer">Agree with Fleet Terms</a>
      </span>
    </div>

    <button
     [disabled]="disableButton || !!(reservationPending$ | async)"
     (click)="makeReservation()"
     nbButton
     class="book-btn"
     [nbSpinner]="!!(reservationPending$ | async)"
    >
     BOOK THIS CAR
    </button>
    <p class="book-hint" *ngIf="bookingBlockedReason as reason">{{ reason }}</p>

  </div>

</div>
